// 작업함 정렬
import { getMe } from 'ts-utils/session'
import { getSearchCookie, setSearchCookie } from 'ts-utils/summary'

const getCookieName = () => {
    const me = getMe()
    if (!me) return null

    return `workspace-order-${me.user_no}`
}

export const CHANGE = 'survey/workspace/change'

interface InitProps {
    value: number;
}

const initState: InitProps = {
    value: 0
}

interface ActionProps {
    type: string;    
    value: number;
}

export default (state = initState, action: ActionProps) => {
    const cookieName = getCookieName()
    switch(action.type) {
        case CHANGE:
            if (cookieName) setSearchCookie(cookieName, action.value)

            return {
                value: action.value
            }
        default:
            const value = cookieName ? getSearchCookie(cookieName) : initState.value

            return {
                ...state,
                value: value || initState.value
            }
    }
}